export enum SyncModalAction {
    CREATE = 'create',
    EDIT = 'edit',
    VIEW = 'view',
    DELETE = 'delete',
}
